<template>
  <div id="SocialList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">廣告商管理</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">廣告</li>
              <li class="breadcrumb-item active">廣告商管理</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-10">
            <div class="b-filter"></div>
          </div>
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              @click="add"
            >
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增广告商
            </button>
          </div>
          <!-- /.col-12 -->
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-form ref="form" label-width="80px" @submit.native.prevent>
                  <el-row>
                    <el-col
                      :md="{ span: 6, offset: 18 }"
                      :sm="{ span: 8, offset: 16 }"
                      :xs="{ span: 14, offset: 10 }"
                    >
                      <el-form-item label="搜尋:">
                        <el-input
                          placeholder="请输入内容"
                          v-model="SGL_Name"
                          clearable
                          @input="handleCurrentChange(1)"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column label="Id" prop="id"></el-table-column>
                  <el-table-column label="圖標" prop="sgL_ImageUrl">
                    <template slot-scope="scoped">
                      <img
                        slot="reference"
                        style="width: 50px; height: 50px"
                        :src="scoped.row.sgL_ImageUrl"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="廣告商名稱" prop="sgL_Name">
                  </el-table-column>
                  <el-table-column label="網址" prop="sgL_Url">
                    <template slot-scope="scoped">
                      <a
                        v-if="
                          scoped.row.sgL_Url.startsWith('https') ||
                          scoped.row.sgL_Url.startsWith('http')
                        "
                        target="_blank"
                        :href="scoped.row.sgL_Url"
                      >
                        {{ scoped.row.sgL_Url }}
                      </a>
                      <a
                        v-else
                        target="_blank"
                        :href="`http://${scoped.row.sgL_Url}`"
                      >
                        {{ scoped.row.sgL_Url }}
                      </a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="加入日期"
                    prop="sgL_CreateTimeF"
                  ></el-table-column>
                  <el-table-column
                    label="聯絡人"
                    prop="sgL_ToUserName"
                  ></el-table-column>
                  <el-table-column
                    label="聯絡電話"
                    prop="sgL_ToPhone"
                  ></el-table-column>
                  <el-table-column
                    label="聯絡電郵"
                    prop="sgL_ToEmail"
                  ></el-table-column>
                  <el-table-column
                    label="負責人"
                    prop="sgL_CreateUsersName"
                  ></el-table-column>
                  <el-table-column
                    label="最後修改日期"
                    prop="sgL_UpdateTimeF"
                  ></el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <span
                        v-if="$store.getters.getAdminUser.userId == 1"
                        class="b-operate-btn b-edit"
                        ><a
                          href="javascript:void(0);"
                          @click="edit(scope.row.id)"
                        >
                          编辑
                        </a></span
                      >
                      <span class="b-operate-btn b-edit"
                        ><a href="javascript:void(0);" @click="del(scope.row)">
                          刪除
                        </a></span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <div
      class="modal fade"
      id="modal-album--filter"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">新增/編輯廣告商</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <el-upload
                class="upload-demo"
                ref="fengmianUpload"
                :action="uploadImageUrl"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="errorUpload"
                :before-upload="uploadImgCheck"
              >
                <button
                  type="button"
                  class="btn btn-block btn-default btn-sm mb-3"
                >
                  Logo上傳
                </button>
              </el-upload>
              <div class="input-group mb-3">
                <img
                  v-if="saveParams.sgL_ImageUrl != ''"
                  :src="saveParams.sgL_ImageUrl"
                  width="100"
                  height="100"
                />
              </div>
            </div>
            <div class="form-group">
              <label>廣告商名稱</label>
              <div class="input-group mb-3">
                <input class="form-control" v-model="saveParams.sgL_Name" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>網址</label>
              <div class="input-group mb-3">
                <input class="form-control" v-model="saveParams.sgL_Url" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>聯絡人</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right"
                  v-model="saveParams.sgL_ToUserName"
                />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>聯絡電話</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right"
                  v-model="saveParams.sgL_ToPhone"
                />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>聯絡電郵</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right"
                  v-model="saveParams.sgL_ToEmail"
                />
              </div>
            </div>
            <!-- <div class="form-group mb-3">
              <label>負責人</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right"
                  v-model="saveParams.sgL_CreateUsersName"
                />
              </div>
            </div> -->
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button type="button" class="btn btn-primary" @click="save">
              保存
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
import base from "../../api/httpApi/base";
export default {
  data() {
    return {
      uploadImageUrl: "",
      SGL_Name: "",
      SocialList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 5, //顯示條數
      },
      loading: false,
      saveParams: {
        id: 0,
        sgL_Name: "",
        sgL_Url: "",
        sgL_ToUserName: "",
        sgL_ToPhone: "",
        sgL_ToEmail: "",
        // sgL_CreateUsersName: "",
        sgL_LogoId: 0,
        sgL_ImageUrl: "",
      },
    };
  },
  created() {
    this.handleCurrentChange(1);
    this.uploadImageUrl = `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=Brand&id=${this.loginUser.userId}`;
  },
  methods: {
    handleSuccess(res, file) {
      this.$refs.fengmianUpload.clearFiles();
      if (res.success) {
        this.saveParams.sgL_LogoId = res.result.uploadId;
        this.saveParams.sgL_ImageUrl = res.result.url;
      } else {
        this.$message.error("上傳失敗:" + res.error.message);
      }
    },
    errorUpload(err, file, fileList) {
      this.$message.error("上傳失敗" + err);
    },
    clearQry() {
      this.saveParams = this.ClearObj(this.saveParams);
    },
    showModel() {
      $("#modal-album--filter").modal("show");
    },
    hideModel() {
      $("#modal-album--filter").modal("hide");
    },
    clear() {
      this.saveParams.id = 0;
    },
    add() {
      this.clearQry();
      this.showModel();
    },
    save() {
      let params = {
        sgL_LogoId: this.saveParams.sgL_LogoId,
        sgL_ImageUrl: this.saveParams.sgL_ImageUrl,
        sgL_Name: this.saveParams.sgL_Name,
        sgL_Url: this.saveParams.sgL_Url,
        sgL_ToUserName: this.saveParams.sgL_ToUserName,
        sgL_ToPhone: this.saveParams.sgL_ToPhone,
        sgL_ToEmail: this.saveParams.sgL_ToEmail,
      };
      let mt = null;
      if (this.saveParams.id > 0) {
        params.id = this.saveParams.id;
        mt = this.$api.ad.AdminBrandUpdate(params);
      } else {
        mt = this.$api.ad.AdminBrandCreate(params);
      }
      mt.then((res) => {
        if (res.data.success) {
          this.hideModel();
          this.handleCurrentChange(1);
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    edit(id) {
      let params = {
        Id: id,
      };
      this.$api.ad.AdminBrandGet(params).then((res) => {
        if (res.data.success) {
          this.saveParams = res.data.result;
          this.showModel();
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    del(item) {
      let msg = `確認刪除廣告商
      「${item.sgL_Name}」？
      廣告商一旦刪除，將無法復原。`;
      this.$confirm(msg, "提示", {
        confirmButtonText: "是，刪除",
        cancelButtonText: "取消",
      }).then(() => {
        let params = {
          Id: item.id,
        };
        this.loading = true;
        this.$api.ad
          .AdminBrandDelete(params)
          .then((res) => {
            if (res.data.success) {
              Message({
                type: "success",
                message: this.$t('message.operatesuccessfully'),
              });
              this.handleCurrentChange(1);
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      });
    },
    getSocialList() {
      let params = {
        SGL_Name: this.SGL_Name,
      };
      this.loading = true;
      this.$api.ad
        .AdminBrandGetAll(params)
        .then((res) => {
          if (res.data.success) {
            this.SocialList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        })
        .then((obj) => {
          this.loading = false;
        });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getSocialList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getSocialList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.SocialList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}
.vid {
  width: 100%;
  height: 100%;
  max-height: 200px;
  object-fit: fill;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminAd/AdVertiserList.vue